var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { memo } from 'react';
import * as React from "react";
var SvgGoogleAccount = /*#__PURE__*/memo(function (props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "M16 11.748c1.302 0 2.18.562 2.68 1.032l1.958-1.91C19.436 9.751 17.872 9.066 16 9.066a6.928 6.928 0 0 0-6.194 3.82l2.242 1.742c.562-1.672 2.118-2.881 3.952-2.881Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M22.656 16.154c0-.57-.046-.986-.146-1.417H16v2.573h3.821c-.077.639-.493 1.602-1.417 2.25l2.187 1.694c1.31-1.21 2.065-2.99 2.065-5.1Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC05",
    d: "M12.055 17.371a4.27 4.27 0 0 1-.23-1.371c0-.478.084-.94.223-1.371l-2.242-1.741A6.94 6.94 0 0 0 9.066 16c0 1.117.27 2.172.74 3.112l2.25-1.74Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M16 22.933c1.872 0 3.444-.616 4.591-1.68l-2.187-1.694c-.586.408-1.372.693-2.404.693-1.833 0-3.39-1.21-3.944-2.88l-2.242 1.74A6.917 6.917 0 0 0 16 22.933Z"
  })));
});
SvgGoogleAccount.displayName = "SvgGoogleAccount";
export default SvgGoogleAccount;